var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
// import Component from "vue-class-component";
import { namespace } from "vuex-class";
var CollectionExecutionModule = namespace("collection-execution");
import { Component } from "vue-property-decorator";
var DoyanPhone = /** @class */ (function (_super) {
    __extends(DoyanPhone, _super);
    function DoyanPhone() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showHotKey = false;
        return _this;
    }
    DoyanPhone.prototype.mounted = function () {
        this.$nextTick(function () {
            var _a;
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://cti.duyansoft.com/syui/dysdk/dysdk2.min.js";
            script.id = "dySdkScript";
            script.setAttribute("url", "https://cti.duyansoft.com?noNumberInput=true");
            script.setAttribute("width", "270");
            script.setAttribute("height", "400");
            (_a = document.querySelector("#content-phone")) === null || _a === void 0 ? void 0 : _a.appendChild(script);
        });
    };
    DoyanPhone.prototype.isShowPhone = function () {
        var _a, _b;
        this.showHotKey = !this.showHotKey;
        if (this.showHotKey && ((_a = document.getElementById("container-content-button")) === null || _a === void 0 ? void 0 : _a.style.display) !== "none") {
            (_b = document.getElementById("icon-hotkey")) === null || _b === void 0 ? void 0 : _b.click();
        }
    };
    DoyanPhone = __decorate([
        Component
    ], DoyanPhone);
    return DoyanPhone;
}(Vue));
export default DoyanPhone;
